import { ru, Translations } from './ru';
import { kk } from './kk';

const translations: Record<string, Translations> = { ru, kk };

export function t(key: string, lang: string = 'ru', params?: Record<string, string>): string {
  const dict = translations[lang] || translations.ru;
  let value = (dict as any)[key] || key;

  // Заполняем параметры: {remaining} → значение
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      value = value.replace(`{${k}}`, v);
    });
  }

  return value;
}

export function useLang(lang: string): Translations {
  return translations[lang] || translations.ru;
}

export { ru, kk };
export type { Translations };
